// types.ts
export type CookieOptions = {
  days?: number;
  path?: string;
};

// cookies.ts
const readCookie = (name: string): string | null => {
  if (typeof window !== "undefined") {
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) {
        const value = c.substring(nameEQ.length, c.length);
        return value.replace(/\+/g, " ");
      }
    }
    return null;
  }
  return null;
};

const setCookie = (
  name: string,
  value: string,
  days?: number,
  path: string = "/",
  domain?: string
): void => {
  if (typeof window !== "undefined") {
    let date, expires;
    if (days) {
      date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    } else {
      expires = "";
    }
    const domainAttr = domain ? `; domain=${domain}` : "";
    document.cookie = name + "=" + value + expires + "; path=" + path + domainAttr + ";secure";
  }
};

const setCookieInfluencer = (): void => {
  if (typeof window !== "undefined") {
    const path = window.location.pathname;
    setCookie("influencer", path.replace(/[\W_]/gm, ""), 365, path);
  }
};

const deleteCookie = (name: string, path = "/"): void => {
  if (typeof window !== "undefined") {
    const expires = "expires=Thu, 01 Jan 1970 00:00:01 GMT";
    const hostname = window.location.hostname;
    const isLocalDev = hostname === "localhost";

    // For local development, cookies are typically set without domain
    if (isLocalDev) {
      document.cookie = `${name}=; ${expires}; path=${path}`;
      document.cookie = `${name}=; ${expires}; path=${path}; secure`;
      document.cookie = `${name}=; ${expires};`;
    } else {
      /* For nutrafol.com domains, try with and without domain attribute */
      // Delete without domain (covers cookies set without domain)
      document.cookie = `${name}=; ${expires}; path=${path}`;
      document.cookie = `${name}=; ${expires}; path=${path}; secure`;
      // Delete with domain=.nutrafol.com (covers all subdomains, i.e. mcstaging.nutrafol.com)
      document.cookie = `${name}=; ${expires}; path=${path}; domain=.nutrafol.com`;
      document.cookie = `${name}=; ${expires}; path=${path}; domain=.nutrafol.com; secure`;
      // Delete with domain=nutrafol.com (covers base domain)
      document.cookie = `${name}=; ${expires}; path=${path}; domain=nutrafol.com`;
      document.cookie = `${name}=; ${expires}; path=${path}; domain=nutrafol.com; secure`;
    }
  }
};

export { readCookie, setCookie, deleteCookie, setCookieInfluencer };
